import { useState } from "react";
import { RotateCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

/** One-click reorder: starts a fresh Stripe checkout for the same property + product. */
export default function OrderAgainButton({ reportId, className = "btn-primary", label = "Order again", testid }) {
  const [loading, setLoading] = useState(false);
  const go = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/orders/reorder/${reportId}`, { origin_url: window.location.origin });
      if (!data?.url) throw new Error("Couldn't start checkout. Please try again.");
      window.location.href = data.url; // redirect to Stripe Checkout
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
      setLoading(false);
    }
  };
  return (
    <button onClick={go} disabled={loading} className={className} data-testid={testid}>
      {loading ? <Loader2 className="animate-spin" size={18} /> : <><RotateCw size={18} /> {label}</>}
    </button>
  );
}
